import * as angular from 'angular';

import { TableListCellRenderMethod } from '../table-list-cell-render-method/table-list-cell-render-method.type';

class TableListCellContentController {
  private renderMethod!: TableListCellRenderMethod;

  methodIs(method: TableListCellRenderMethod) {
    return this.renderMethod === method;
  }
}

export const TableListCellContentComponent: angular.IComponentOptions = {
  controller: TableListCellContentController,
  controllerAs: 'ctrl',
  transclude: true,
  bindings: {
    column: '<',
    renderMethod: '<',
    value: '<',
  },
  template: `
    <span
      class="row-cell row-{{ctrl.column}}-col"
      ng-if="ctrl.methodIs('${TableListCellRenderMethod.Icon}')"
    >
      <mode-report-type-icon [type]="ctrl.value.data"></mode-report-type-icon>
    </span>
    <span
      class="row-cell row-cell-text row-{{ctrl.column}}-col"
      ng-if="ctrl.methodIs('${TableListCellRenderMethod.Text}')"
    >
      <span>{{ctrl.value.data}}</span>
    </span>
    <span
      class="row-cell row-cell-content row-{{ctrl.column}}-col"
      ng-if="ctrl.methodIs('${TableListCellRenderMethod.BadgeWithText}')"
    >
      <capra-badge ng-if="ctrl.value.data.badgeText" [text]="ctrl.value.data.badgeText" [type]="ctrl.value.data.badgeType"></capra-badge>
      <mode-publish-badge-icon ng-if="ctrl.value.data.badgeIconType === 'publish'" class="publish-badge"></mode-publish-badge-icon>
      <span ng-if="ctrl.value.data.text">{{ctrl.value.data.text}}</span>
    </span>
    <span
      class="row-cell row-{{ctrl.column}}-col"
      ng-bind-html="ctrl.value.data"
      ng-if="ctrl.methodIs('${TableListCellRenderMethod.Html}')"
    />
    <span
      class="row-cell row-{{ctrl.column}}-col"
      ng-if="ctrl.methodIs('${TableListCellRenderMethod.Transclude}')"
      ng-transclude
    />
    <span ng-if="ctrl.methodIs('${TableListCellRenderMethod.Avatar}')" class="row-cell row-{{ctrl.column}}-col">
      <mode-avatar
        options="ctrl.value.data.avatar"
        size="{{ctrl.value.data.size}}"
      ></mode-avatar>
    </span>
  `,
};
